import { render, staticRenderFns } from "./tsl.vue?vue&type=template&id=6a1093eb&scoped=true&"
var script = {}
import style0 from "./tsl.vue?vue&type=style&index=0&id=6a1093eb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a1093eb",
  null
  
)

export default component.exports